import { jsx } from "panel";
import { MarkdownEl } from "../markdown";
import { SvgIconEl } from "../svg-icon";
export function template() {
  const icon = this.attr("icon");
  const textBefore = this.attr("text-before-icon");
  return /* @__PURE__ */ jsx("span", { "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { attrs: {
    elref: "textHighlight"
  }, sel: ".mp-text-highlight", class: {
    [this.attr("theme")]: true,
    ["size-".concat(this.attr("size"))]: true,
    ["length-".concat(this.attr("length"))]: true,
    ["no-wrap"]: this.attr("no-wrap")
  } }, icon && !textBefore && /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon
  } }), this.attr("text") && /* @__PURE__ */ jsx("div", { sel: ".text" }, this.attr("text")), this.attr("markdown") && /* @__PURE__ */ jsx("div", { sel: ".markdown.text" }, /* @__PURE__ */ jsx(MarkdownEl, { attrs: {
    text: this.attr("markdown")
  } })), icon && textBefore && /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon
  }, class: {
    "text-before-icon": true
  } })), /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" }));
}
